import React from 'react';

const subsectionHeadings = new Set([
  'Account Owner', 'Other Users', 'Current Launch Pricing', '90-Day Trial',
  'Automatic Renewal', 'Monthly Forklift Quantity', 'Annual Forklift Quantity',
  'Payment Issues', 'Refunds and Credits', 'Customer Cancellation',
  'Suspension by ManageLift', 'Termination for Cause',
  'ManageLift Termination Without Cause', 'Ownership',
  'Permission to Process Customer Data', 'Personal Information',
  'Record Access and Export', 'Submitted Names and Signatures', 'Availability',
  'Security', 'Backups and Data Loss', 'Service Changes', 'Assignment',
  'Force Majeure', 'No Waiver', 'Severability', 'Relationship of the Parties',
  'Entire Agreement and Order of Precedence',
]);

export default function LegalText({ text }) {
  const blocks = text.trim().split(/\n\s*\n/);
  return blocks.map((block, index) => {
    const value = block.replace(/\n+/g, ' ').replace(/\s+/g, ' ').trim();
    if (/^\d+\. [^;]+$/.test(value) && !/^\d+\. {2,}/.test(block)) {
      return <h2 key={index}>{value}</h2>;
    }
    if (subsectionHeadings.has(value)) return <h3 key={index}>{value}</h3>;
    if (/^\d+\.\s{2,}/.test(block)) return <p key={index} className="legal-numbered-item">{value}</p>;
    return <p key={index}>{linkify(value, index)}</p>;
  });
}

function linkify(value, key) {
  const pieces = value.split(/(support@managelift\.com|\/privacy|\/terms)/g);
  return pieces.map((piece, index) => {
    if (piece === 'support@managelift.com') return <a key={`${key}-${index}`} href="mailto:support@managelift.com">{piece}</a>;
    if (piece === '/privacy' || piece === '/terms') return <a key={`${key}-${index}`} href={piece}>{piece}</a>;
    return piece;
  });
}
